import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { ReactQRCode } from '@lglab/react-qr-code';
import { useDisclosure, useMediaQuery } from '@chakra-ui/react';
import Modal from '@/src/components/Modal/Modal';
import Flexbox from '@/components/common/Flexbox';
import { FaMinus, FaTimes } from 'react-icons/fa';
import useModal from '@/src/hooks/useModal';

const QRCodeFloatingButton = () => {
  const [isReallyClose, setIsReallyClose] = useState(false);
  const [isOpenDelay, setIsOpenDelay] = useState(false);

  const [aboveTablet] = useMediaQuery('(min-width: 768px)');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { shouldVisible } = useModal(isOpen, 0, 300);

  useEffect(() => {
    if (isOpen) {
      const id = setTimeout(() => setIsOpenDelay(true), 100);
      return () => clearTimeout(id);
    } else {
      setIsOpenDelay(false);
    }
  }, [isOpen]);

  const onReallyClose = useCallback(() => {
    setIsReallyClose(true);
    onClose();
  }, []);

  return (
    <React.Fragment>
      <Modal show={shouldVisible} transparent zIndex={1000}>
        <Flexbox
          align={'center'}
          justify={'center'}
          direction={'column'}
          className={clsx(
            'sm:fixed',
            'w-full h-full',
            'sm:w-100 sm:h-[80vh] sm:max-h-[40rem]',
            'bg-white',
            'sm:transition-all sm:duration-300',
            'sm:bottom-8',
            'sm:transform',
            isOpenDelay ? ['sm:left-8 sm:translate-x-0'] : ['sm:left-0', 'sm:-translate-x-full']
          )}
        >
          <Flexbox align={'center'} justify={'end'} className={clsx('w-full')}>
            <Flexbox
              as={'button'}
              // @ts-ignore
              type={'button'}
              align={'center'}
              justify={'center'}
              className={clsx('h-12 w-12')}
              onClick={onClose}
            >
              {/*@ts-ignore*/}
              <FaMinus size={24} />
            </Flexbox>
            <Flexbox
              as={'button'}
              // @ts-ignore
              type={'button'}
              align={'center'}
              justify={'center'}
              className={clsx('h-12 w-12')}
              onClick={onReallyClose}
            >
              {/*@ts-ignore*/}
              <FaTimes size={24} />
            </Flexbox>
          </Flexbox>
          <Flexbox
            as={'a'}
            href={`https://lin.ee/n2YbIPq`}
            target={'_blank'}
            rel={'noopener noreferrer'}
            align={'center'}
            justify={'center'}
            className={clsx('flex-1', 'w-full')}
          >
            <ReactQRCode
              value={'https://line.me/ti/p/@funwoo'}
              level={'M'}
              marginSize={3}
              minVersion={1}
              size={210}
              dataModulesSettings={{ style: 'square-sm' }}
              finderPatternOuterSettings={{ style: 'rounded-sm' }}
              finderPatternInnerSettings={{ style: 'rounded-sm' }}
              imageSettings={{ src: '/assets/images/icons/line.svg', width: 66, height: 22, excavate: true }}
              boostLevel={false}
            />
          </Flexbox>
        </Flexbox>
      </Modal>
      {isReallyClose ? null : (
        <React.Fragment>
          <button
            className={clsx(
              'hidden sm:flex',
              'fixed z-50',
              'bg-white',
              'hover:cursor-pointer',
              'sm:left-8 sm:bottom-8',
              'sm:w-[90px] sm:h-[90px]'
            )}
            onClick={onOpen}
          >
            <ReactQRCode
              value={'https://line.me/ti/p/@funwoo'}
              level={'M'}
              marginSize={3}
              minVersion={1}
              size={aboveTablet ? 90 : 60}
              dataModulesSettings={{ style: 'square-sm' }}
              finderPatternOuterSettings={{ style: 'rounded-sm' }}
              finderPatternInnerSettings={{ style: 'rounded-sm' }}
              imageSettings={{ src: '/assets/images/icons/line.svg', width: 24, height: 8, excavate: true }}
              boostLevel={false}
            />
          </button>
          <Flexbox
            as={'a'}
            href={`https://lin.ee/n2YbIPq`}
            target={'_blank'}
            rel={'noopener noreferrer'}
            align={'center'}
            justify={'center'}
            className={clsx(
              'sm:hidden',
              'fixed z-50',
              'bg-white',
              'hover:cursor-pointer',
              'left-5 bottom-16',
              'w-15 h-15'
            )}
            onClick={onOpen}
          >
            <ReactQRCode
              value={'https://line.me/ti/p/@funwoo'}
              level={'M'}
              marginSize={3}
              minVersion={1}
              size={aboveTablet ? 90 : 60}
              dataModulesSettings={{ style: 'square-sm' }}
              finderPatternOuterSettings={{ style: 'rounded-sm' }}
              finderPatternInnerSettings={{ style: 'rounded-sm' }}
              imageSettings={{ src: '/assets/images/icons/line.svg', width: 24, height: 8, excavate: true }}
              boostLevel={false}
            />
          </Flexbox>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default QRCodeFloatingButton;
